import React, { useState, useEffect } from "react";
import { Box, Menu, X } from "lucide-react";
import { NAV_LINKS } from "../mock";

const Logo = () => (
  <a href="#top" className="flex items-center gap-3 select-none">
    <Box className="text-[#e8730c]" size={40} strokeWidth={1.6} />
    <div className="leading-none">
      <div
        className="text-white font-bold"
        style={{
          fontFamily: "'Barlow Condensed', sans-serif",
          fontSize: "22px",
          letterSpacing: "0.02em",
          lineHeight: "0.98",
        }}
      >
        STRUCTURAL<br />INNOVATIONS
      </div>
      <div
        className="text-[#e8730c] font-semibold mt-1"
        style={{
          fontFamily: "'Barlow Condensed', sans-serif",
          fontSize: "11px",
          letterSpacing: "0.35em",
        }}
      >
        ISLE OF MAN
      </div>
    </div>
  </a>
);

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      id="top"
      className="fixed top-0 left-0 w-full z-50 transition-all duration-300"
      style={{
        background: scrolled ? "rgba(13,27,46,0.97)" : "#0d1b2e",
        boxShadow: scrolled ? "0 8px 24px rgba(0,0,0,0.25)" : "none",
      }}
    >
      <div className="si-container flex items-center justify-between" style={{ height: 92 }}>
        <Logo />

        <nav className="hidden lg:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a key={l.label} href={l.href} className="nav-link">
              {l.label}
            </a>
          ))}
          <a href="#contact" className="btn-outline-orange" style={{ padding: "12px 26px" }}>
            Contact Us
          </a>
        </nav>

        <button
          className="lg:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden" style={{ background: "#0d1b2e", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
          <div className="si-container flex flex-col py-5 gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="nav-link"
                onClick={() => setOpen(false)}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              className="btn-outline-orange text-center"
              onClick={() => setOpen(false)}
            >
              Contact Us
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
